// extracted by mini-css-extract-plugin
export default {"container":"TnkqSCA4Ex6iaKWgN_uc","title":"qGfqUGeTaMHxSTXbxkeA","subtitle":"kkrnkVd5WEe8BH1gGb4o","illustrationContainer":"dv04poqEhwrNOV_C0ykK","pulse":"QkSphW2_aYdXP3POmXRw"};